__turbopack_context__.v({
  "fullPage": "_5VEEQa_fullPage",
  "suspenseFallback": "_5VEEQa_suspenseFallback",
  "waitText": "_5VEEQa_waitText",
});
